import { Observable } from "rxjs";
import { AbstractScreenHandler, CRUDGenericService, TypeValidatorService } from 'attcei-bo-fw';
import { ScreenHandler } from 'attcei-bo-fw/lib/screen/interfaces/ScreenHandler';
import { Injectable } from '@angular/core';
import { PaginationState } from 'attcei-bo-fw/lib/classes/PaginationState';
import { Sort } from '@angular/material/sort';
import { PaginatedDTO } from 'attcei-bo-fw/lib/classes/dto/PaginatedDTO';
import { BasicRouteTemplateDTO } from '../classes/dto/BasicRouteTemplateDTO';
import { RouteTemplateDTO } from '../classes/dto/RouteTemplateDTO';

@Injectable({
    providedIn:'root'
})

export class RouteTemplateScreenHandler extends AbstractScreenHandler<BasicRouteTemplateDTO, RouteTemplateDTO> implements ScreenHandler<BasicRouteTemplateDTO, RouteTemplateDTO>{
    constructor(private service: CRUDGenericService, typeValidator: TypeValidatorService){
        super(typeValidator);
    }
    
    loadListData(filter: any, paginationState: PaginationState, sort: Sort): Observable<PaginatedDTO<RouteTemplateDTO>> {
        var url:string = this.getURL() + this.buildInvocationWithPaginationAndFilter(paginationState, filter, sort);
        return this.service.getDataList(url, true);
    }

    post(item: BasicRouteTemplateDTO):Observable<RouteTemplateDTO> {
        console.log("Recebi no post -> ", item);
        var dto: BasicRouteTemplateDTO = super.parse(item);
        var res: Observable<RouteTemplateDTO> = this.service.postData(this.getURL(),dto,true);
        console.log("result -> ", res);
        return res;
    }

    update(item: RouteTemplateDTO):Observable<RouteTemplateDTO> {
        console.log("Recebi no update -> ", item);
        var dto: RouteTemplateDTO = super.parse(item);
        var res: Observable<RouteTemplateDTO> = this.service.putData(this.getURL(), dto.id, dto, true);
        console.log("parsed -> ", res);
        return res;
    }

    delete(item: any):Observable<RouteTemplateDTO> {
        return this.service.delete(this.getURL(), item.id, true);
    }

    getItem(id: number):Observable<RouteTemplateDTO> {
        return this.service.getDataItem(this.getURL(), true, id);
    }

    getURL(): string {
        return "routes/template"
    }

    getId(item: RouteTemplateDTO): number {
        return item.id;
    }
    
    protected getUpdateTypeName(): string {
        return "RouteTemplateDTO";
   
    }    
    
    protected getCreateTypeName(): string {
        return "BasicRouteTemplateDTO";
    }
}